/**
 The responsiveFontSize() function helps you to build responsive font size,
 */
import pxToRem from 'assets/theme/functions/pxToRem';

function responsiveFontSizes({ xs, sm, md, lg, xl }) {
  return {
    '@media (min-width:0px)': {
      fontSize: pxToRem(xs)
    },
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm)
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md)
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg)
    },
    '@media (min-width:1536px)': {
      fontSize: pxToRem(xl)
    }
  };
}

export default responsiveFontSizes;
